import { PokerCategory } from '@repo/database/src/types';

import { TableParamsDto } from './table-params.dto';

export interface CreateTemplateDto extends TableParamsDto {
  name: string;
  maxPlayers: number;
  game: string;
  category: PokerCategory;
  minStake: number;
  maxStake: number;
  bettingStructure: string;
  isPublic?: boolean;
}
